/**
 * Case Study Detail Page
 * Displays individual case study using the template
 */

import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { CaseStudyTemplate } from '@/components/caseStudy/CaseStudyTemplate';
import { theOpulentCaseStudy } from '@/data/caseStudies/theOpulent';
import { ExtendedCaseStudy } from '@/types/caseStudy';

// Map of all case studies
const caseStudiesMap: { [key: string]: ExtendedCaseStudy } = {
  'the-opulent-virtual-assistant-success': theOpulentCaseStudy,
  // Add more case studies here as they're created
};

const CaseStudyDetail = () => {
  const { slug } = useParams<{ slug: string }>();
  
  // Find the case study by slug
  const caseStudy = slug ? caseStudiesMap[slug] : null;
  
  if (!caseStudy) {
    return (
      <>
        <Header />
        <div className="min-h-screen bg-gradient-to-br from-[#1f4ed1] via-[#2256e5] to-[#1f4ed1] flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-white mb-4">Case Study Not Found</h1>
            <p className="text-white/80 mb-6">The case study you're looking for doesn't exist.</p>
            <Link to="/case-studies">
              <Button className="bg-white/10 backdrop-blur-sm text-white border border-white/20 hover:bg-white/20">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Case Studies
              </Button>
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }
  
  return (
    <>
      <Header />
      <div className="pt-16">
        {/* Back Button - Simple Arrow */}
        <div className="absolute top-24 left-8 z-50">
          <Link to="/case-studies">
            <Button className="bg-white/10 backdrop-blur-sm text-white border border-white/20 hover:bg-white/20 group rounded-full p-3">
              <ArrowLeft className="h-5 w-5 group-hover:-translate-x-1 transition-transform" />
            </Button>
          </Link>
        </div>
        <CaseStudyTemplate caseStudy={caseStudy} />
      </div>
      <Footer />
    </>
  );
};

export default CaseStudyDetail;